export default "__VITE_ASSET__xDdYGE_2__"